var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_375_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1977_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_542_",
    d: "M20.1,19.7H5.9c-3.2,0-5.9-2.6-5.9-5.9v-1.7c0-3.2,2.6-5.9,5.9-5.9h14.3c3.2,0,5.9,2.6,5.9,5.9v1.7 C26,17.1,23.4,19.7,20.1,19.7z M5.9,8c-2.3,0-4.2,1.9-4.2,4.2v1.7c0,2.3,1.9,4.2,4.2,4.2h14.3c2.3,0,4.2-1.9,4.2-4.2v-1.7 c0-2.3-1.9-4.2-4.2-4.2H5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1976_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_539_",
    d: "M20.1,19.7H5.9c-3.2,0-5.9-2.6-5.9-5.9v-1.7c0-3.2,2.6-5.9,5.9-5.9h14.3c3.2,0,5.9,2.6,5.9,5.9v1.7 C26,17.1,23.4,19.7,20.1,19.7z M5.9,8c-2.3,0-4.2,1.9-4.2,4.2v1.7c0,2.3,1.9,4.2,4.2,4.2h14.3c2.3,0,4.2-1.9,4.2-4.2v-1.7 c0-2.3-1.9-4.2-4.2-4.2H5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1975_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1226_",
    d: "M21,13c0,1.6-1.3,2.9-2.9,2.9h0c-1.6,0-2.9-1.3-2.9-2.9v0c0-1.6,1.3-2.9,2.9-2.9h0 C19.7,10.1,21,11.4,21,13L21,13z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/Toggle.1f595159a08ab23e5aacbc220c430d6b.svg";
export { ForwardRef as ReactComponent };